export interface EcoReportConfigsForm {
  distance: boolean;
  fuelUsed: boolean;
  fuelUsage: boolean;
  fuelUsageDriving: boolean;
  cruiseControlFuel: boolean;
  cruiseControlInterruption: boolean;
  freeRolling: boolean;
  parkingBrake: boolean;
  brakingDistance: boolean;
  brakingPercentage: boolean;
  numberOfStops: boolean;
  harshBraking: boolean;
  averageSpeed: boolean;
  engineLoadFuel: boolean;
  engineLoadFuelPercentage: boolean;
  averageWeight: boolean;
  noCargo: boolean;
  lightCargo: boolean;
  mediumCargo: boolean;
  heavyCargo: boolean;
  idlingTime: boolean;
  fuelUsedIdling: boolean;
  distanceTill80: boolean;
  distance80To81: boolean;
  distance82To83: boolean;
  distance84To85: boolean;
  distanceOver85: boolean;
  co2: boolean;
  ptoFuel: boolean;
  ptoDuration: boolean;
  gradient: boolean;
  onlinePercentage: boolean;
}

export class EcoReportConfigsForm {

  public static defaultValues(): EcoReportConfigsForm {
    return {
      distance: true,
      fuelUsed: true,
      fuelUsage: true,
      fuelUsageDriving: true,
      cruiseControlFuel: true,
      cruiseControlInterruption: true,
      freeRolling: true,
      parkingBrake: true,
      brakingDistance: true,
      brakingPercentage: true,
      numberOfStops: true,
      harshBraking: true,
      averageSpeed: true,
      engineLoadFuel: true,
      engineLoadFuelPercentage: true,
      averageWeight: true,
      noCargo: true,
      lightCargo: true,
      mediumCargo: true,
      heavyCargo: true,
      idlingTime: true,
      fuelUsedIdling: true,
      distanceTill80: true,
      distance80To81: true,
      distance82To83: true,
      distance84To85: true,
      distanceOver85: true,
      co2: true,
      ptoFuel: true,
      ptoDuration: true,
      gradient: true,
      onlinePercentage: true
    };
  }
}
